import { render, staticRenderFns } from "./MensagemOut.vue?vue&type=template&id=00a2b670&"
import script from "./MensagemOut.vue?vue&type=script&lang=js&"
export * from "./MensagemOut.vue?vue&type=script&lang=js&"
import style0 from "./MensagemOut.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports